import React from 'react';
import { reportClientError } from 'lib/clientErrorReporter';

function summarizeComponentTrace(componentTrace = '') {
  return String(componentTrace || '')
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean)
    .slice(0, 8)
    .join(' | ')
    .slice(0, 500);
}

export default class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    reportClientError('react_render_error', error, {
      componentTrace: summarizeComponentTrace(info?.componentStack),
    }, { force: true });
  }

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <main className="min-h-screen bg-canvas px-6 py-16 text-ink">
        <div className="mx-auto flex min-h-[60vh] max-w-3xl flex-col justify-center">
          <p className="font-body text-xs font-semibold uppercase tracking-[0.32em] text-[#d6b36a]">
            Magellan International
          </p>
          <h1 className="mt-6 font-heading text-4xl leading-tight md:text-6xl">
            This page did not load correctly.
          </h1>
          <p className="mt-6 max-w-2xl font-body text-base leading-8 text-copy/70 md:text-lg">
            Refresh the page and try again. If the issue continues, contact support@magellan-tms.com.
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="mt-8 w-fit rounded-full border border-[#d6b36a]/70 bg-[#d6b36a] px-6 py-3 font-body text-xs font-bold uppercase tracking-[0.18em] text-black transition hover:bg-[#f0cf7a]"
          >
            Refresh page
          </button>
        </div>
      </main>
    );
  }
}
